import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PATHS from "../../../Routes/paths";
import { Popover, PopoverTrigger, PopoverContent, PopoverBody, PopoverFooter, PopoverCloseButton, Button, IconButton, } from "@chakra-ui/react";
import { NotifList } from "../../Molecules";

import { BellIcon, DashboardIcon, AnalyticsIcon, DealerIcon, OrdersIcon, InventoryIcon, SettingsIcon, BellAlertIcon, LeaseIcon, OrderManagementIcon, InstallationVideoIcon, DealerManagement, CloseIcon, StatisticsIcon, AlertsIcon, RideIcon, VehicleActivity, SearchIcon, ManageShipmentIcon, LiveTrackingIcon, MultipleUsers, BulkOperationIcon, DeviceSubscriptionIcon, ArchivedIcon, DriverManagementIcon, PlansWarrantyIcon } from "../../../Assets/images/svgs";
import "./styles.css";
import { AuthContext, StoreContext } from "../../../Library/contexts";
import { DRAWER_ACCESS_CODES, MAX_RESPONSIVE_BREAKPOINT_WIDTH, SELLER_DES, SUBDEALERS_DES, VALID_CHASSIS_LENGTH, VALID_IMEI_LENGTH, VALID_NEW_ORDER_ID_LENGTH, VALID_ORDER_ID_LENGTH, VALID_SHIP_ID_LENGTH } from "../../../Library/constants";
import { useDebounce } from "../../../Hooks";
import { getSearchSuggestions } from "../../../APIs";
import { Spinner } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";
import { getItemFromLocalStorage } from "../../../Library/helpers";
import { Title } from "../../Atoms";
import { Notifications } from "../../../Pages"

let IS_USER = getItemFromLocalStorage("user");
let ACCESS_CODES = getItemFromLocalStorage("accessCodes") || [];
let DESIGNATION = getItemFromLocalStorage("des");

const routes = {
  [DRAWER_ACCESS_CODES.DASHBOARD]: {
    icon: <DashboardIcon />,   title: "Dashboard",            to: PATHS.DASHBOARD
  },
  [DRAWER_ACCESS_CODES.ANALYTICS]: {
    icon: <AnalyticsIcon />,   title: "Analytics",            to: PATHS.ANALYTICS
  },
  [DRAWER_ACCESS_CODES.DEALER]: {
    icon: <DealerIcon />,      title: "Dealer Management",    to: PATHS.DEALER
  },
  [DRAWER_ACCESS_CODES.ORDERS]: {
    icon: <OrdersIcon />,      title: "Orders",               to: PATHS.ORDERS
  },
  [DRAWER_ACCESS_CODES.INVENTORY]: {
    icon: <InventoryIcon />,   title: "Inventory Management", to: PATHS.INVENTORY
  },
  [DRAWER_ACCESS_CODES.LEASE]: {
    icon: <LeaseIcon />,       title: "Lease",                to: PATHS.LEASE
  },
  [DRAWER_ACCESS_CODES.SETTINGS]: {
    icon: <SettingsIcon />,    title: "Settings",             to: PATHS.PROFILE
  },
  [DRAWER_ACCESS_CODES.DEALERS_OVERVIEW]: {
    icon: <DashboardIcon />,   title: "Dashboard",            to: PATHS.DEALERS_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.ORDERS_OVERVIEW]: {
    icon: <OrderManagementIcon />,   title: (DESIGNATION === SUBDEALERS_DES ? "Manage Shipment" : "Order Management"),    to: PATHS.ORDERS_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.INVENTORY_OVERVIEW]: {
    icon: <InventoryIcon />,   title: "Inventory Management",    to: PATHS.INVENTORY_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.INSTALLATION_VIDEO]: {
    icon: <InstallationVideoIcon />,   title: "Tutorial Videos",    to: PATHS.INSTALLATION_VIDEO
  },
  [DRAWER_ACCESS_CODES.DEALER_MANAGEMENT]: {
    icon: <DealerManagement />,   title: "Dealer Management",    to: PATHS.SHOW_DEALERS,
  },
  [DRAWER_ACCESS_CODES.SHIPMENT_OVERVIEW]: {
    icon: <ManageShipmentIcon />,   title: "Manage Shipments",    to: PATHS.SHIPMENT_OVERVIEW
  },
  [DRAWER_ACCESS_CODES.LIVE_TRACKING]: {
    icon: <LiveTrackingIcon />,   title: "Live Tracking",    to: PATHS.LIVE_TRACKING
  },
  [DRAWER_ACCESS_CODES.ALL_VEHICLE_STATS]: {
    icon: <StatisticsIcon />,   title: "Statistics",    to: PATHS.ALL_VEHICLE_STATS
  },
  [DRAWER_ACCESS_CODES.SET_ALERTS]: {
    icon: <AlertsIcon />,    title: "Set Alerts",     to: PATHS.SET_ALERTS,
  },
  [DRAWER_ACCESS_CODES.ROUTES]: {
    icon: <RideIcon />,      title: "Routes",     to: PATHS.VIEW_ROUTES,
  },
  [DRAWER_ACCESS_CODES.VEHICLE_ACTIVITY]: {
    icon: <VehicleActivity />,  title: "Vehicle Activity",   to: PATHS.VEHICLE_ACTIVITY,
  },
  [DRAWER_ACCESS_CODES.SUB_USERS]: {
    icon: <MultipleUsers />,  title: "Subusers",      to: PATHS.SUB_USERS,
  },
  [DRAWER_ACCESS_CODES.BULK_OPERATION]: {
    icon: <BulkOperationIcon />,  title: "Bulk Operation",   to: PATHS.BULK_OPERATIONS,
  },
  [DRAWER_ACCESS_CODES.DEVICE_SUBSCRIPTION]: {
    icon: <DeviceSubscriptionIcon />,  title: "Device Subscription",   to: PATHS.DEVICE_SUBSCRIPTION,
  },
  [DRAWER_ACCESS_CODES.DRIVER_MANAGEMENT]: {
    icon: <DriverManagementIcon />,  title: "Driver Management",   to: PATHS.DRIVER_MANAGEMENT,
  },
  [DRAWER_ACCESS_CODES.DRIVER_ROUTE_CHECK]: {
    icon: <LiveTrackingIcon />,  title: "Route Selection",   to: PATHS.DRIVER_ROUTE_CHECK,
  },
  [DRAWER_ACCESS_CODES.ROUTE_HISTORY]: {
    icon: <RideIcon />,  title: "Route History",   to: PATHS.ROUTE_HISTORY,
  },
  [DRAWER_ACCESS_CODES.PLANS_AND_WARRANTY]: {
    icon: <PlansWarrantyIcon />,  title: "Plans & Warranty",   to: PATHS.PLANS_AND_WARRANTY,
  },
};

const links = {
    top: [
      routes[DRAWER_ACCESS_CODES.ANALYTICS],
      routes[DRAWER_ACCESS_CODES.INVENTORY],
      routes[DRAWER_ACCESS_CODES.LEASE],
    ],
    bottom: [ routes[DRAWER_ACCESS_CODES.SETTINGS] ],
};

if (ACCESS_CODES && ACCESS_CODES.length) {
  let DRAWER_TOP_LINKS = [];

  let isSeller = DESIGNATION === SELLER_DES;
  ACCESS_CODES.forEach(code => {
    // if (isSeller && code === DRAWER_ACCESS_CODES.ORDERS_OVERVIEW) return;
    if (!isSeller && code === DRAWER_ACCESS_CODES.SHIPMENT_OVERVIEW) return;
    if (routes[code]) DRAWER_TOP_LINKS.push(routes[code]);
  });

  if (DRAWER_TOP_LINKS.length) {
    links.top = DRAWER_TOP_LINKS;
  }
};


const getSelectedTab = ({ pathname }) => {
  let index = null;

  index = links.top.findIndex((link) => pathname.startsWith(link.to));
  if (index > -1) {
    return { position: "top", index: index };
  }

  if (links.bottom) {
    index = links.bottom.findIndex((link) => pathname.startsWith(link.to));
    if (index > -1) {
      return { position: "bottom", index: index };
    }
  }

  return { position: "notifications", index: index };
};

const SEARCH_SUGGESTIONS_VALUE_KEYS = {
  imei: "imei",
  order: "reqkey",
  shipment: "reqkey",
  chassis: "chNum",
}

const placeholders = [
  "Search IMEI",
  "Search Order ID",
  "Search Shipment ID",
  "Search Chassis Number"
];

const ORDER_PREFIX_CHAR = "o";
const SHIPMENT_PREFIX_CHAR = "s";
const MIN_IMEI_LENGTH_REQ = 8;
const MIN_CHASSIS_LENGTH_REQ = 3;


const DrawerComponent = ({ showDrawer, hideDrawer, user, codes }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { assets, profile } = useContext(AuthContext);
  const { activeRouteTrip, hasExpiredSubs } = useContext(StoreContext);

  const [ selected, setSelected ] = useState(getSelectedTab(location));
  const [ isMobileView ] = useState(window.innerWidth < MAX_RESPONSIVE_BREAKPOINT_WIDTH);

  if (codes && codes.length) {
    let DRAWER_TOP_LINKS = [];

    let isSeller = DESIGNATION === SELLER_DES;
    codes.forEach(code => {
      // if (isSeller && code === DRAWER_ACCESS_CODES.ORDERS_OVERVIEW) return;
      if (!isSeller && code === DRAWER_ACCESS_CODES.SHIPMENT_OVERVIEW) return;

      if (routes[code]) DRAWER_TOP_LINKS.push(routes[code]);
    });

    if (DRAWER_TOP_LINKS.length) {
      links.top = DRAWER_TOP_LINKS;
    }
  };

  if (profile?.driverLogin) {
    links.top = [
      routes[DRAWER_ACCESS_CODES.DRIVER_ROUTE_CHECK],
      // routes[DRAWER_ACCESS_CODES.ROUTE_HISTORY],
    ].filter(Boolean);
  }

  const [ selectedSearchCategory, setSelectedSearchCategory ] = useState("imei");
  const [ selectedSearchCategoryKey, setSelectedSearchCategoryKey ] = useState(SEARCH_SUGGESTIONS_VALUE_KEYS.imei);
  const [ searchSuggestions, setSearchSuggestions ] = useState([]);
  const searchSuggestionsRef = useRef(null);

  const [searchText, handleSearch] = useDebounce(fetchSearchSuggestions, 1000);
  const [loading, setLoading] = useState(false);
  const [noSuggestions, setNoSuggestions] = useState(false);
  const inputRef = useRef(null);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);
  const [currentPlaceholder, setCurrentPlaceholder] = useState(0);

  useEffect(() => {
    if (!DESIGNATION) DESIGNATION = getItemFromLocalStorage("des");
    setSelected(getSelectedTab(location));
  }, [ location ]);

  const getPosition = () => {
    const { position, index } = selected;

    if (position === "top") {
      const PADDING = (IS_USER || user) ? 60 : 145;
      return { transform: `translateY(calc(${100 * index}% + ${PADDING}px))` };
    }
    if (position === "bottom") {
      const PADDING = 156;
      return { transform: `translateY(calc(100vh - (${(100 * index)}% + ${PADDING}px)))` };
    }

    return { transform: `translate(245.5px, -30px)`, height: 40, width: 40, borderRadius: "50%", padding: 0 };
  };

  const renderLink = (position, { icon, title, to }, index) => {
    const style = { transform: position === "top" ? `translateY(calc(100% * ${index}))` : `translateY(calc(-100% * ${index}))` };
    let className = "drawer-link drawer-item ";
    if (position === "bottom") className += "drawer-end-link ";

    if (position === selected.position && index === selected.index) className += "drawer-active-link";

    return (
      <Link key={index} style={style} className={className} to={to} onClick={() => hideDrawer()}>
        {icon}
        {title}
        {(to === PATHS.DRIVER_ROUTE_CHECK && activeRouteTrip) && <span className="status-dot green"></span>}
        {(to === PATHS.PLANS_AND_WARRANTY && hasExpiredSubs) && <span className="status-dot red"></span>}
      </Link>
    )
  };

  const validateText = (text) => {
    if (text.length > 1 && text.length <= VALID_SHIP_ID_LENGTH && text[0].toLowerCase() === SHIPMENT_PREFIX_CHAR) {
      return { isValid: true, identifier: 'shipment' };
    }
    if (text.length > 1 && ((text.length <= VALID_NEW_ORDER_ID_LENGTH && text[0].toLowerCase() === ORDER_PREFIX_CHAR) || (text.length <= VALID_ORDER_ID_LENGTH && isNaN(text[0])))) {
      return { isValid: true, identifier: 'order' };
    }
    if (text.length >= MIN_IMEI_LENGTH_REQ && text.length <= VALID_IMEI_LENGTH && Number(text)) {
      return { isValid: true, identifier: 'imei' };
    }
    if (text.length >= MIN_CHASSIS_LENGTH_REQ && text.length <= VALID_CHASSIS_LENGTH && isNaN(text[0])) {
      return { isValid: true, identifier: 'chassis' };
    }

    return { isValid: false };
  };

  const resetSearch = () => {
    setNoSuggestions(false);
    setSearchSuggestions([]);
  };

  function fetchSearchSuggestions (text) {
    if (searchSuggestions.length && !searchSuggestionsRef.current.length) return;
    const { isValid, identifier } = validateText(text);

    if (!isValid) return resetSearch();

    setSelectedSearchCategory(identifier);
    setSelectedSearchCategoryKey(SEARCH_SUGGESTIONS_VALUE_KEYS[identifier]);
    setSelectedOptionIndex(-1);
    setLoading(true);

    getSearchSuggestions(identifier, text, (err, data) => {
      if (err) console.error(err);
      else {
        setNoSuggestions(!data?.length);
        setSearchSuggestions(data || []);
        searchSuggestionsRef.current = data;
        if (data && data.length === 1) {
          setSelectedOptionIndex(0);
        }
      }
      setLoading(false);
    });
  }

  const handleOptionClick = (option, e) => {
    e.stopPropagation();
    if (!option) return;

    const navigateTo = {
      imei: `${DESIGNATION === SELLER_DES ? PATHS.SHOW_DEALERS : PATHS.INVENTORY_OVERVIEW}/${PATHS.SPECIFIC_DEVICE}?imei=${option.imei}${DESIGNATION === SELLER_DES ? `&idx=${option.dlrId}&inStock=true&installed=true` : ""}`,
      order: `${PATHS.DEALERS_OVERVIEW}${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?idx=${option.reqkey}`,
      shipment: `${DESIGNATION === SUBDEALERS_DES ? "" : PATHS.SHIPMENT_OVERVIEW}${PATHS.ORDERS_OVERVIEW}/${PATHS.ORDER_DETAIL}?shipId=${option.reqkey}`,
      chassis: `${DESIGNATION === SELLER_DES ? PATHS.SHOW_DEALERS : PATHS.INVENTORY_OVERVIEW}/${PATHS.SPECIFIC_DEVICE}?imei=${option.imei}${DESIGNATION === SELLER_DES ? `&idx=${option.dlrId}&inStock=true&installed=true` : ""}`,
    }

    setSearchSuggestions([]);
    searchSuggestionsRef.current = [];
    handleSearch({ target: { value: `${option[selectedSearchCategoryKey]}` } });

    navigate(navigateTo[selectedSearchCategory]);
  }

  const handleInputFocus = () => {
    if (!searchSuggestions.length && searchText.length) setSearchSuggestions(searchSuggestionsRef.current);
  }

  const handleOnChange = (e) => {
    if (e.target.value.length >= 20) return;
    e.target.value = e.target.value.replace(/[^\w]|_/g, '');
    handleSearch(e)
  }

  useEffect(() => {
    function handleClick (e) {
      if (inputRef.current && !inputRef.current.contains(e.target)) {
        searchSuggestionsRef.current = searchSuggestions;
        resetSearch();
      }
    }
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, [searchSuggestions]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown") {
        if (selectedOptionIndex < searchSuggestions.length - 1) setSelectedOptionIndex(selectedOptionIndex + 1); 
        else if (selectedOptionIndex === searchSuggestions.length - 1) setSelectedOptionIndex(0);
      }
      else if (e.key === "ArrowUp") {
        if (selectedOptionIndex > 0) setSelectedOptionIndex(selectedOptionIndex - 1);
        else if (selectedOptionIndex === 0) setSelectedOptionIndex(searchSuggestions.length - 1);
      }
      else if (e.key === "Enter") {
        if (selectedOptionIndex > -1) handleOptionClick(searchSuggestions[selectedOptionIndex], e);
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [searchSuggestions, selectedOptionIndex]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPlaceholder((prev) => (prev + 1) % placeholders.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={`drawer-main ${showDrawer ? "show-drawer" : "hide-drawer"}`}>
      <header className="drawer-header">
        <div className="drawer-header-brand">
          {isMobileView ? <CloseIcon onClick={() => hideDrawer()} /> : <img alt="logo" src={assets.assetUrl + "/" + assets.logo} />}
        </div>
        {ACCESS_CODES.includes(DRAWER_ACCESS_CODES.NOTIFICATIONS) ? <NotificationsPopover active={selected.position === "notifications"} navigate={() => navigate(PATHS.NOTIFICATIONS)} /> : null}
      </header>
      { (!IS_USER && !user) && <div className="global-search-container">
        {loading ? <Spinner className="spinner" /> : <SearchIcon className="global-search-field-icon" />}
        <div className="search-placeholder-container">
        {!searchText && (
            <AnimatePresence mode="sync">
              <motion.div
                key={currentPlaceholder}
                initial={{ y: "100%", opacity: 0 }}
                animate={{ y: "0%", opacity: 1 }}
                exit={{ y: "-100%", opacity: 0 }}
                transition={{ type: "tween", duration: 0.8, ease: "easeInOut" }}
                className="animated-placeholder"
              >
                {placeholders[currentPlaceholder]}
              </motion.div>
            </AnimatePresence>
        )}
        </div>
        <input
          ref={inputRef}
          value={searchText}
          onChange={handleOnChange}
          className="global-search-input"
          onFocus={handleInputFocus}
          placeholder=""
          max={20}
        />
        <div className="search-suggestion-dropdown">
          {
            (searchSuggestions && searchSuggestions.length) ? searchSuggestions.map((suggestion, i) => (
              <span key={i} className={`search-option-text ${selectedOptionIndex === i ? "selected-option" : ""}`} onClick={(e) => handleOptionClick(suggestion,e)}>
                {suggestion[selectedSearchCategoryKey]}
              </span>
            )) : noSuggestions ? <span className="no-option-text">No Suggestions Found</span> : null
          }
        </div>
        {searchText ? <CloseIcon className="close-icon" onClick={() => {
          resetSearch();
          handleSearch({ target: { value: "" } });
        }} /> : null}
      </div>}

      <div
        style={getPosition()}
        className="drawer-active drawer-item"
      />

      <main position="relative">
        {Object.keys(links).map((position) => {
          return links[position].map((...e) => renderLink(position, ...e));
        })}
      </main>

      {((searchSuggestions && searchSuggestions.length) || noSuggestions) ? <div className="blur-bg"></div> : null}
    </div>
  );
};

const NotificationsPopover = ({ active, navigate }) => {
  const { notifications } = useContext(StoreContext);
  const [ isOpen, setIsOpen ] = useState(false);

  const onOpen = () => {
    if (active) return;
    setIsOpen(true);
  }
  const onClose = () => setIsOpen(false);

  const handleAll = () => {
    onClose();
    navigate();
  };

  let Icon = (!active && notifications && notifications.unreadCount > 0) ? BellAlertIcon : BellIcon;

  return (
    <div>
      <Popover placement="right" isOpen={isOpen} onOpen={onOpen} onClose={onClose}>
        <PopoverTrigger>
          <IconButton
            icon={<Icon className={active ? "notif-active" : ""} />}
            variant="ghost"
            colorScheme="blackAlpha"
            rounded="full"
            zIndex={5}
            className="bell-icon"
          />
        </PopoverTrigger>

        <PopoverContent className="notif-container">
          <PopoverCloseButton rounded="full" />
          <div className="notif-title-cnt">
            <Title>Notifications</Title>
          </div>
          <PopoverBody>
           {isOpen ? <Notifications fromDrawer/> : null}
          </PopoverBody>

          <PopoverFooter className="notif-footer">
            <Button colorScheme="cyan" variant="link" onClick={handleAll}>
              View All
            </Button>
          </PopoverFooter>
        </PopoverContent>
      </Popover>

      {isOpen && <div className="panel-overlay" />}
    </div>
  );
};

export default DrawerComponent;
